export default __webpack_public_path__ + "static/easy-booking-4b49433b5bc5ec6188e0a3b8d1ec9501.png";